import { render } from "./Card2.vue?vue&type=template&id=2fca58cd"
import script from "./Card2.vue?vue&type=script&lang=ts"
export * from "./Card2.vue?vue&type=script&lang=ts"
script.render = render

export default script